/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import { connect } from 'react-redux';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import _, { isNull, isUndefined } from 'lodash';
import { StyledModal, StyledBody, MainContent, PeerButton } from '../RecognitionList/styles';
import {
  FeedInformation, SliderContainer,
  ImageWrapper, WrapImage, InputFieldContainer, RecognitionSection,
  FieldContainer,  Description, CommentContent, SendButton,
  RecognitionImage, InputTextAreaComment, PostTopSection, AddButton,
  LikeCommentButtonSection, LikeCommentButton, LikeCommentCount, RecognitionBirthdayAnniversary,
  MultiphotoWrapper, Multiphoto, UserInitials, UserInitialsMain, DownAngleV2, RecogntionContainer,
  ReactionsContainer,
  PostReactionsContainer,
  LinkPreviewCard,
  MonthlyGoalChallengeCard
} from './styles';
import Image from '../Image';
import SocialFeedTextarea from './SocialFeedTextarea';
import { ImageUrl } from '../../utils/constants';
import { /*convertDateInTimezone,*/ getTimeToShow, applyHighlights, convertUnicode, checkImage, getOrientation, resetOrientation, /*convertMonthFromDate,*/ createSafeHTML, fetchApi, getInitials, getReceiverNameColor, commaSeperator, capitalizeFirstLetter } from '../../utils/methods';
import { getUserPosts, addCommentOnPost, disableButton, likeUnlikePost, getUserName, getUserId, sendFriendRequest, unFriendUser, getPostLikeDetails, addBuddy, getSuggestionsList, getFeedHighlights, getCommentsOnPost } from '../../redux/actions';
import { withTranslation } from 'react-i18next';
import SocialFeedsEmojiPicker from '../SocialFeedsEmojiPicker';
import { IconContainer } from '../EventDetails/styles';
import LazyImage from '../common/LazyImage/LazyImage';
import DeletePostPopUp from '../DeletePostPopup/deletePostConfirmation';
import RemoveFriendPopup from './RemoveBuddyPopUp/removeBuddyPoupUpdated';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { AddBuddyIconNew, CommunityIcon, CongratulationsEmojiIcon,PendingIcon,SocialFeedCommentIcon,VerticalDotsIcon  } from '../../utils/icons';
import ShareWorkoutCard from '../LogWorkoutCategoryV2/shareWorkoutCard';
import ReportPostPopup from './ReportPostPopup';
import {PublicIcon} from '../../utils/icons'
import { Divider } from '../RecogntionAdmin/styles';
import { /*GetSocialTipsAndQuotes,*/ GetMetaDataOfURL, LikeUnlikePostV2 } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import ViewCommentModal from '../ViewCommentModal';
import { getInspirationPost, updateDetailPost, updateSocialFeedPost } from '../../redux/actions/socialActions';
import EditPostPopup from './EditPostPopup';

class SingleFeed extends Component {
  constructor(props) {
    super();
    this.state = {
      showTextArea: false,
      commentText: '',
      notBase64: false,
      time: [],
      mentionedUsers: [],
      users: [],
      showGivenShoutout: false,
      shoutoutText: null,
      shoutoutImage: null,
      userIdArray: [],
      linkMetaMap: {} ,
      taggedUser: '',
      shoutoutType: 0,
      exemplifyID: null,
      showAddBuddy: false,
      linkMetadata: null,
      metadataLoading: false,
      showReportPopup: false,
      showRemoveBuddyButton: false,
      showRemoveBuddyPopUp: false,
      ShowEmojiContainer: false,
      displayEmojiPicker: false,
      likeUsers: [],
      showRecognitionModal: false,
      postId: '',
      currentButton: '',
      feedLikeStatus: null,
      showViewCommentModal: props.showViewCommentModal ? props.showViewCommentModal : false,
      hideCommentText: props.hideCommentText === false ? false : true,
      postLikeDetail: [],
      userIdArrayV2: [],
      usersV2: [],
      position: { start: 0, end: 0 },
      showCommentArea: false,
      imgSrc: [],
      messageLength: 0,
      showFullCommentBox: false,
      selectedCommentBox: null,
      postIdValue:null,
      showFullText: false,
      reactionHoverFeed:null,
      likedType:null,
      showDetailsPopup:false,
      // defaultReactions:[]
      showEditPopup: false,

    }
    this.myref = React.createRef();
    this.inputRef = React.createRef();
  }

  handleClick = (event) => {
    if (!isNull(this.myref) && !isUndefined(this.myref) && !(this.myref && !isNull(this.myref.current) && !isUndefined(this.myref.current) && this.myref.current.contains(event.target))) {
      this.setState({ ShowEmojiContainer: false });
    }
  };

  toggleEditPopup = () => {
    this.setState((prev) => ({ showEditPopup: !prev.showEditPopup }));
  };
  handleComment= (id) => {
    this.setState({ showFullCommentBox: true, selectedCommentBox: id });
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClick);
    // this.getGlobalAnnouncementData();
    const { feed } = this.props;

    this.loadAllLinkPreviews();
    // if (feed && feed.liked_status === 1) {
    //   this.setState({
    //     feedLikeStatus: true,
    //     likedType:feed?.liked_type
    //   })
    // } else {
    //   this.setState({
    //     feedLikeStatus: false,
    //     likedType:null
    //   })
    // }

    this.checkBase64(this.props.profileImage);
    if (!this.props.userName) this.props.fetchUserName();
    if (!this.props.userId) this.props.fetchUserId();
    this.setState({
      time: getTimeToShow(feed, 'feeds')
    });

    this.interval = setInterval(() => this.setState({
      time: getTimeToShow(feed, 'feeds')
    }), 60 * 1000);

    if (feed.friend_status === 1) {
      this.setState({
        currentButton: 'Remove Buddy'
      })
    } else if (feed.friend_status === 0) {
      this.setState({
        currentButton: 'Add Buddy'
      })
    } else if (feed.friend_status === 2) {
      this.setState({
        currentButton: 'Pending'
      })
    } else {
      this.setState({
        currentButton: ''
      })
    }
  }


  componentWillUnmount() {
    setInterval(() => clearInterval(this.interval), 65 * 1000);
    document.removeEventListener("mousedown", this.handleClick);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if (this.props.successLikeOrUnlike !== nextProps.successLikeOrUnlike) {
    //   this.setState({
    //     clicked: false
    //   });
    // }
    if (this.props.profileImage != nextProps.profileImage) {
      this.checkBase64(nextProps.profileImage);
    }

    if (this.props.feed !== nextProps.feed) {
      this.setState({
        time: getTimeToShow(nextProps.feed, 'feeds')
      });
    }
  }

  loadAllLinkPreviews = async () => {
    const { feed } = this.props;
    // Your JSON shows post text is in feed.text
    if (!feed || !feed.text) return;

    const url = this.extractUrl(feed.text);
    if (!url) return;

    // Fetch only for this specific component instance
    await this.fetchLinkMetadata(url);
  };

  fetchLinkMetadata = async (url) => {
    try {
      this.setState({ metadataLoading: true });
      const payload = { url: url };
      const res = await fetchApi(GetMetaDataOfURL, "POST", payload);

      if (res?.success === "success" || res?.title) {
        this.setState({
          linkMetadata: res.data || res, // Save the object directly
          metadataLoading: false,
        });
      } else {
        this.setState({ metadataLoading: false });
      }
    } catch (error) {
      this.setState({ metadataLoading: false, linkMetadata: null });
    }
  };

  componentDidUpdate(prevProps) {
    // const {feed}= this.props
    if (this.props.postLikeDetails !== prevProps.postLikeDetails) {

      let feeds = this.props.storedFeeds;
      let feed = feeds && (feeds.response && feeds.response.length > 0 ? feeds.response : feeds)
      if (feed) {
        let feedIndex = feed.findIndex((data) => data.id == this.state.postId);
        if (feedIndex !== -1) {
          feed[feedIndex].post_like_users = this.props.postLikeDetails;
          this.props.updateFeedsLike(feed);
          this.setState({ postLikeDetail: this.props.postLikeDetails, postId: '' });
        }
      }


    }

    // if(feed !== prevProps.feed){
    //   if (feed && feed.liked_status === 1) {
    //     this.setState({
    //       feedLikeStatus: true,
    //       likedType:feed?.liked_type
    //     })
    //   } else {
    //     this.setState({
    //       feedLikeStatus: false,
    //       likedType:null
    //     })
    //   }
    // }
  }

  checkBase64(profileImage) {
    if (profileImage) {
      let arr = profileImage.split('/');
      if (arr[0] !== 'profile-Image') {
        this.setState({
          notBase64: false
        })
      }
      else {
        this.setState({
          notBase64: true
        })
      }
    }
  }

  showAddBuddyPopUp2 = () => {
    this.setState({ showAddBuddy: false });
  }

  closeReportPostPopup = () => {
    this.setState({ showReportPopup : false });
  }

  showReportPostPopup = () => {
    this.setState({ showReportPopup : true });
  }

  showAddBuddyPopUp = (ID) => {
    const { addBuddy, feed } = this.props;
    this.setState({ showAddBuddy: true });
    addBuddy(ID);
    if (feed.friend_status === 1) {
      this.setState({
        currentButton: 'Remove Buddy'
      })
    } else if (feed.friend_status === 0) {
      this.setState({
        currentButton: 'Add Buddy'
      })
    } else if (feed.friend_status === 2) {
      this.setState({
        currentButton: 'Pending'
      })
    } else {
      this.setState({
        currentButton: ''
      })
    }
  }

  showTextArea = () => {
    this.setState((prev) => ({
      showTextArea: !prev.showTextArea
    }));
  };

  setRemoveBuddy = () => {
    // const { unFriendUser } = this.props;
    this.setState((prev) => ({ showRemoveBuddyButton: !prev.showRemoveBuddyButton }));
    // unFriendUser(ID, true);
  }

  handleLikePopUp = () => {
    const { handleModal, handleFeed, feed } = this.props
    handleModal();
    handleFeed(feed.id);
  }

  likeUnlikeFeedPost = async(data, /*reaction*/)=>{
    const{post_id,flag}=data;
    const finalPayload = {
      post_id,
      flag,
      comment_id:null,
      reply_comment_id:null
    }

    const res = await fetchApi(LikeUnlikePostV2, "POST", finalPayload);
    if(res.status === 'success'){
      // toast.success(res?.data?.[0]);
      // this.setState((prev) => ({
      //   postId: '',
      //   feedLikeStatus: reaction ? true : !prev.feedLikeStatus,
      //   likedType:reaction ? flag : prev.feedLikeStatus ? null : 'like',
      //   postLikeDetail: []
      // }), () => this.setState({ postId: this.props.feed.id }));
      const payload = {
        post_id: res?.data?.id,
        updatedData: res?.data
      }
      
      this.props.updateSocialFeedPost(payload);
      this.props.updateDetailPost(res?.data)
    }else{
      toast.error(res?.data?.[0]);
    }

  }

  likeUnlikePost = () => {
    const { /*likeOrUnlikePost, disableLikeButton,*/ feed, /*updationList*/ } = this.props;
    const likeData = {
      post_id: feed.id,
      flag: feed && feed.liked_status === 1 ? 'unlike' : 'like',
    };
    // this.setState((prev) => ({
    //   clicked: true,
    //   isPostLiked: !prev.isPostLiked,
    //   postId: '',
    //   feedLikeStatus: !prev.feedLikeStatus,
    //   likedType:prev.feedLikeStatus ? null : 'like',
    //   postLikeDetail: []
    // }), () => this.setState({ postId: feed.id }));
    // disableLikeButton();
    // likeOrUnlikePost(likeData, updationList || 'response');
    this.likeUnlikeFeedPost(likeData);
  };

  handleReactionClick = (reaction) => {
    const { /*likeOrUnlikePost, disableLikeButton,*/ feed, /*updationList*/ } = this.props;
    const likeData = {
      post_id: feed.id,
      // flag: feed && feed.liked_status === 1 ? 'unlike' : 'like',
      flag:reaction
    };
    // this.setState((prev) => ({
    //   clicked: true,
    //   isPostLiked: !prev.isPostLiked,
    //   postId: '',
    //   feedLikeStatus: true,
    //   postLikeDetail: [],
    //   likedType:reaction
    // }), () => this.setState({ postId: feed.id }));
    // disableLikeButton();
    // likeOrUnlikePost(likeData, updationList || 'response');
    this.likeUnlikeFeedPost(likeData, true);
  };

  addComment = () => {
    const { users, userIdArray, commentText, taggedUser, mentionedUsers, exemplifyID, imgSrc } = this.state;
    const { postComment, feed, updationList, getCommentsForPost } = this.props;
    let shoutout = {
      exemplifies: mentionedUsers.length > 0 ? mentionedUsers : userIdArray
    };
    let comment = this.toCodePoints(commentText), shoutout_user_name = '';
    if (!_.isEmpty(mentionedUsers) || !_.isEmpty(userIdArray)) {
      shoutout_user_name = `${applyHighlights(users, userIdArray, taggedUser)} - ${this.state.shoutoutText}`;
    }
    let exemplify_id = exemplifyID;
    if (shoutout.exemplifies.length >= 1 || commentText !== ""||imgSrc.length >0) {
      postComment({ post_id: feed.id, comment, shoutout, shoutout_user_name, exemplify_id, image: imgSrc.length >= 1 ? imgSrc[0] : '' }, updationList);
    }
    this.setState({
      showTextAreaFor: null,
      commentText: '',
      showGivenShoutout: false,
      shoutoutImage: null,
      shoutoutText: null,
      taggedUser: '',
      userIdArray: [],
      users: [],
      mentionedUsers: [],
      displayEmojiPicker: false,
      shoutoutType: 0,
      userIdArrayV2: [],
      usersV2: [],
      imgSrc: [],
      messageLength: 0
    }, () => getCommentsForPost(feed.id))
  };

  onChangeValue = (e) => {
    let position = this.getPosition(e.target)
    let text = e.target.value;
    this.setState({
      commentText: text,
      position: position
    });
  };

  toCodePoints = function (string) {
    let chars = "";
    for (let i = 0; i < string.length; i++) {
      let c1 = string.charCodeAt(i);
      let b1 = string.charAt(i);
      if (c1 >= 0xD800 && c1 < 0xDC00 && i + 1 < string.length) {
        let c2 = string.charCodeAt(i + 1);
        if (c2 >= 0xDC00 && c2 < 0xE000) {
          chars = chars + ("&#" + ((+0x10000 + ((c1 - 0xD800) << 10) + (c2 - 0xDC00))) + ";</span>");
          i++;
          continue;
        }
      }
      else {
        chars = chars + b1;
      }
    }
    return chars;
  }

  getPosition(el) {
    let start = 0, end = 0, normalizedValue, range,
      textInputRange, len, endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end
    };
  }

  addInspirationV2 = (e) => {
    let newText = this.state.commentText.slice(0, this.state.position.start) + e.native + this.state.commentText.slice(this.state.position.end);
    this.setState({
      position: { start: this.state.position.start + e.native.length, end: this.state.position.end + e.native.length },
      commentText: newText,
    });
  };

  updateText = (text, userId, taggedUserName) => {
    const { userIdArray, users, taggedUser } = this.state;
    let userIdArr = [...userIdArray];
    let userNameArr = [...users];
    let taggedUsers = taggedUser;
    if (userIdArr.indexOf(userId) === -1) {
      userIdArr.push(userId);
      userNameArr.push(taggedUserName);
      if (!_.isEmpty(taggedUsers))
        taggedUsers = `${taggedUsers}, ${taggedUserName}`;
      else
        taggedUsers = taggedUserName;
    }
    this.setState({
      commentText: text,
      userIdArray: userIdArr,
      users: userNameArr,
      // taggedUser: taggedUsers,
      // showGivenShoutout: bool
    });
  };

  updateShoutoutArray = (mentionedUsers, text, image, exemplifies_id) => {
    this.setState({
      showGivenShoutout: true,
      shoutoutText: text,
      shoutoutImage: image,
      shoutoutType: exemplifies_id ? exemplifies_id : null,
      mentionedUsers: mentionedUsers,
      exemplifyID: exemplifies_id ? exemplifies_id : null
    });
  };

  onRemoveShoutout = (array) => {
    this.setState({
      [array]: [],
      showGivenShoutout: false,
      taggedUser: '',
      shoutoutImage: null,
      shoutoutText: null,
      userIdArray: [],
      users: [],
      usersV2: '',
      userIdArrayV2: []
    });
  };

  onRemoveUser = () => {
    this.setState({
      taggedUser: '',
      showGivenShoutout: false,
      userIdArray: [],
      shoutoutImage: null,
      shoutoutText: null,
      users: []
    });
  };

  updateTextV2 = (text, userId, taggedUserName, bool) => {
    const { userIdArrayV2, usersV2, taggedUser, userIdArray } = this.state;
    let userIdArr = [...userIdArrayV2];
    let userNameArrV2 = [...usersV2];
    let userIdAll = [...userIdArray]
    let taggedUsers = taggedUser;
    if (userIdArr.indexOf(userId) === -1) {
      userIdArr.push(userId);
      userIdAll.push(userId);
      userNameArrV2.push(taggedUserName);
      if (!_.isEmpty(taggedUsers))
        taggedUsers = `${taggedUsers}, ${taggedUserName}`;
      else
        taggedUsers = taggedUserName;
    }
    this.setState({
      userIdArrayV2: userIdArr,
      usersV2: userNameArrV2,
      taggedUser: taggedUsers,
      showGivenShoutout: bool,
      userIdArray: userIdAll
    });
  };


  togglePostButton = (value) => {
    const { shoutoutText, userIdArray } = this.state;
    if (userIdArray.length !== 0) {
      if (userIdArray.length !== 0 && !_.isNull(shoutoutText)) {
        return false;
      } else
        return true;
    } else if (value && value.trim() !== '') {
      return false;
    }
    return true;
  };

  displayEmojiContainer = () => {
    this.setState((prev) => ({
      ShowEmojiContainer: !prev.ShowEmojiContainer
    }));
  }

  showEmojiPicker = () => {
    this.setState((prev) => ({
      displayEmojiPicker: !prev.displayEmojiPicker
    }))
  }

  removeImage = () => {
    this.setState({
      imgSrc: [],
      messageLength: 0
    });
  };

  onChangeImage = (e) => {
    let file = e.target.files[0];
    this.setState({
      messageLength: e.target.value.length >= 1 ? "1" : '0'
    });
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          this.setState({
            imgSrc: [reader.result],
            refreshFileReader: true,
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: [baseImage],
                refreshFileReader: false
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById(`${this.props.feed.id}-"upload"`).value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById(`${this.props.feed.id}-"upload"`).value = '';
    }
  };

  updatePosition = (position) =>{
    this.setState({
      position:{start: this.state.position.start+position, end: this.state.position.end+position }
    })
  }

  renderTextArea = (value) => {
    const { enableTrigger } = this.props;
    return (
      <FieldContainer isCommentOrReply socialPage borderBottom={"1"} width paddingBottom marginBottom>
        {/* <span>Comments</span> */}
        <CommentContent heightValue height={this.state.showGivenShoutout ? 1 : 0} h1={this.state.imgSrc.length}>
          <ImageWrapper isCommentSection>
            {this.imgSrc(true)}
          </ImageWrapper>
          <InputFieldContainer comment padding={'15px'} height={'100%'} width isCommentOrReply>
            <SocialFeedTextarea
              userCompany={this.props.userCompany}
              addInspiration={this.onChangeValue}
              addInspirationV2={this.addInspirationV2}
              updateTextV2={this.updateTextV2}
              inspirationQuote={this.state.commentText}
              updateText={this.updateText}
              users={this.state.users}
              usersV2={this.state.usersV2}

              userIdArray={this.state.userIdArray}
              placeholder={this.props.t("Write a comment...")}
              showGivenShoutout={this.state.showGivenShoutout}
              updateShoutoutArray={this.updateShoutoutArray}
              emptyShoutoutArray={this.emptyShoutoutArray}
              onRemoveShoutout={this.onRemoveShoutout}
              isCommentOrReply={"isCommentOrReply"}
              shoutoutText={this.state.shoutoutText}
              shoutoutImage={this.state.shoutoutImage}
              taggedUser={this.state.taggedUser}
              onRemoveUser={this.onRemoveUser}
              enableTrigger={enableTrigger}
              ShowEmojiContainer={this.state.ShowEmojiContainer}
              myref={this.myref}
              className={'CustomTextAreaField'}
              selectedImage={this.state.imgSrc[0]}
              shoutOutData={null}
              removeImage={this.removeImage}
              updatePosition={this.updatePosition}
            />

            <IconContainer cameraIcon style={{ width:"20%",justifyContent: "flex-end", position:"initial", marginTop:"0px", display: "flex", margin: "0 auto 5px" }}>
              <div style={{width:"46px", height:"46px", border:"1px solid #005C874D", display:"flex", borderRadius:"50%"}}>
                <img style={{ marginTop: '0px', cursor: 'pointer', width: '27px', height: '27px', margin:"auto" }} onClick={this.showEmojiPicker} src={ImageUrl+"/social-feed/Emoji.png"}></img>
              </div>
              <SendButton disabled={this.state.commentText.length > 0 || this.state.userIdArray.length > 0||this.state.imgSrc.length>0?0:1} onClick={this.state.commentText.length > 0 || this.state.userIdArray.length > 0||this.state.imgSrc.length>0? () => this.addComment():null}>
                <img src={ImageUrl + "/social-feed/sendButton.png"} onClick={this.state.commentText.length > 0 || this.state.userIdArray.length > 0||this.state.imgSrc.length>0? /*() => this.addComment()*/null:null}/>
              </SendButton>  
              {/* <InputImage htmlFor={`${this.props.feed.id && this.props.feed.id}-"upload"`} noMarginTop style={{ background: 'none', padding:"0px 10px" }}>
                <img src={ImageUrl + "/social-feed/cameraIcon.png"} />
                <input
                  id={`${this.props.feed.id}-"upload"`}
                  type="file"
                  name={("image")}
                  accept=".jpeg, .png, .jpg*"
                  multiple={false}
                  onChange={(e) => this.onChangeImage(e)}
                  // onClick={(e) => e.target.files[0] && this.onChangeImage(e)}
                />
              </InputImage> */}
            </IconContainer>

            {/* <Option>
              <div onClick={() => handlePhotoPostModal(1, this.props.feed.id)}>
                <img src="/public/images/camera_icon.svg" />
              </div>
              <div onClick={() => this.showEmojiPicker()}>
                <img src='/public/images/emoji_icon.svg' />
              </div> */}
            {/* <div onClick={this.addComment} disabled={this.togglePostButton(value)}>
                <img style={{ marginTop: '5px' }} src="/public/images/social/send.svg" />
              </div> */}
            {/* </Option> */}
          </InputFieldContainer>
        </CommentContent>
        {/* {this.state.commentText.length > 0 || this.state.userIdArray.length > 0||this.state.imgSrc.length>0? <PostButton margin color="#159fc9" onClick={() => this.addComment()}>Post <img src='/public/images/SendPost.svg' /></PostButton> : null} */}
        {this.state.displayEmojiPicker ? <SocialFeedsEmojiPicker comment selectEmoji={this.addInspirationV2} hidePicker={this.showEmojiPicker}></SocialFeedsEmojiPicker> : null}

        <RecognitionSection>
          <div>
            <div onClick={() => this.displayEmojiContainer()}>
              <img src="/public/images/social/peer_recognition.svg" />
            </div>
            <div>
              <img src="/public/images/CommentReplyImages/camera.png" />
              <input
                id="uploadPhoto"
                type="file"
                name="image"
                accept=".jpeg, .png, .jpg*"
                multiple={false}
                onChange={(e) => this.props.onChange(e)}
                onClick={(e) => e.target.files[0] && this.props.onChange(e)}
              />
            </div>
            <div onClick={() => this.showEmojiPicker()}>
              <img src="/public/images/CommentReplyImages/Emoji_2.png" />
            </div>
          </div>
          <button onClick={()=>this.addComment()} disabled={this.togglePostButton(value)}>
            <img src="/public/images/CommentReplyImages/addPost.png" />
          </button>
        </RecognitionSection>
      </FieldContainer>
    )
  }

  handleActivation = () => {
    this.inputRef.current.focus();
  };

  renderTextAreaComments = (value) => {
    const { displayEmojiPicker } = this.state;
    return (
      <FieldContainer isCommentOrReply socialPage borderBottom={"1"} width paddingBottom marginBottom>
        <CommentContent heightValue height={this.state.showGivenShoutout ? 1 : 0} h1={this.state.imgSrc.length}>
          <ImageWrapper isCommentSection>
            {this.imgSrc(true)}
          </ImageWrapper>
          <InputTextAreaComment>
            <textarea
              placeholder={this.props.t("Add a comment....")}
              rows="4"
              name=""
              onClick={() => this.handleComment(this.props.feed.id)}
              data-gramm_editor="false"
              spellCheck="false" 
              ref={this.inputRef}     
              autoFocus={0} 
            >
            </textarea>
          </InputTextAreaComment>
        </CommentContent>
        {displayEmojiPicker ? <SocialFeedsEmojiPicker comment selectEmoji={this.addInspirationV2} hidePicker={this.showEmojiPicker}></SocialFeedsEmojiPicker> : null}

        <RecognitionSection>
          <div>
            <div onClick={() => this.displayEmojiContainer()}>
              <img src="/public/images/social/peer_recognition.svg" />
            </div>
            <div>
              <img src="/public/images/CommentReplyImages/camera.png" />
              <input
                id="uploadPhoto"
                type="file"
                name="image"
                accept=".jpeg, .png, .jpg*"
                multiple={false}
                onChange={(e) => this.props.onChange(e)}
                onClick={(e) => e.target.files[0] && this.props.onChange(e)}
              />
            </div>
            <div onClick={() => this.showEmojiPicker()}>
              <img src="/public/images/CommentReplyImages/Emoji_2.png" />
            </div>
          </div>
          <button /*onClick={this.addComment}*/ disabled={this.togglePostButton(value)}>
            <img src="/public/images/CommentReplyImages/addPost.png" />
          </button>
        </RecognitionSection>
      </FieldContainer>
    )
  }


  navigateUserProfile = (uid) => {
    const { history, userId, fetchUserPosts } = this.props;
    fetchUserPosts(uid, history);
    if (userId === uid) {
      history.push('/profile');
    } else {
      history.push(`/profile/${uid}`);
    }
  };

  imgSrc = (isOwn) => {
    const { userId, feed, profileImage } = this.props;
    const { notBase64 } = this.state;
    if (isOwn) {
      if (!notBase64) {
        return (<img src={`${ImageUrl}/${profileImage}`} />)
      }
      else {
        return (<Image image={profileImage} />)
      }
    } else if (userId == feed?.post_owner?.uid) {
      if (!notBase64) {
        return (<img src={`${ImageUrl}/${profileImage}`} /*onClick={() => this.navigateUserProfile(feed?.post_owner?.uid)}*/ />)
      }
      else {
        return (<Image image={profileImage} /*onClick={() => this.navigateUserProfile(feed?.post_owner?.uid)}*/ />)
      }
    }
    else {
      return (<LazyImage  src={feed.profile_image ? `${ImageUrl}/${feed.profile_image}` : '/public/images/neutral_avatar.svg'} image={feed.profile_image} /*onClick={() => this.navigateUserProfile(feed?.post_owner?.uid)}*/ />)
    }
  };

  getTaggedUserId = (e) => {
    if (e.target.id) {
      this.navigateUserProfile(e.target.id);
    }
  };

  displayRemovePopUp = () => {
    const { socialCallBack, feed } = this.props;
    this.setState((prev) => ({ showRemoveBuddyPopUp: !prev.showRemoveBuddyPopUp }));
    if (feed.friend_status === 1) {
      this.setState({
        currentButton: 'Remove Buddy'
      })
    } else if (feed.friend_status === 0) {
      this.setState({
        currentButton: 'Add Buddy'
      })
    } else if (feed.friend_status === 2) {
      this.setState({
        currentButton: 'Pending'
      })
    } else {
      this.setState({
        currentButton: ''
      })
    }
    socialCallBack();
  }

  showRecognition = () => {
    this.setState((prev) => ({
      showRecognitionModal: !prev.showRecognitionModal
    }));
  }

  onShoutoutSelect = (text, id, image) => {
    const { userIdArray } = this.state;
    this.setState((prev) => ({
      showRecognitionModal: !prev.showRecognitionModal,
      shoutoutText: text,
      shoutoutImage: image,
      shoutoutType: id ? id : null,
      exemplifyID: id ? id : null
    }));
    this.updateShoutoutArray(userIdArray, text, image, id);
  }

  renderRecognitionModal = () => {
    const { exemplifiesValues } = this.props;
    return (
      <div>
        <StyledModal
          show={this.state.showRecognitionModal}
          onHide={this.showRecognition}
        >
          <StyledBody style={{ padding: '0px' }}>
            <MainContent>
              {
                exemplifiesValues ? exemplifiesValues.map((recognition) => (
                  <PeerButton
                    value={recognition.core_value}
                    onClick={() => this.onShoutoutSelect(recognition.core_value, recognition.id, recognition.image)}
                    key={recognition.id}
                  >
                    <img src={`${ImageUrl}/${recognition.image}`} height={recognition.image.includes('passionate.png') ? '30px' : '20px'} />
                    <div>{recognition.core_value}</div>
                  </PeerButton>
                ))
                  : null
              }
            </MainContent>
          </StyledBody>
        </StyledModal>
      </div>
    )
  }

  renderViewCommentModal = () => {
    this.setState((prev) => ({
      showViewCommentModal: !prev.showViewCommentModal
    }))
    this.props.handleScrollTrigger();
  }

  showCommentBox = () => {
    this.setState((prev) => ({
      showCommentArea: !prev.showCommentArea
    }))
  }

  addBuddyApiCall= (id) =>{
    this.props?.sendFriendRequest(id);
    this.props?.getSuggestionsList();
    this.props?.socialCallBack && this.props?.socialCallBack();
  }

  fallBack = (e) => {
    e.target.src = "/public/images/neutral_avatar.svg";
  };

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }

  showFullText = (id)=> {
    this.setState({
      showFullText: true,
      postIdValue: id
    })
  }

  onReactionEnterMouse = (id)=>{
    this.setState({reactionHoverFeed:id})

  }

  onReactionLeaveMouse=()=>{
    this.setState({reactionHoverFeed:null})
  }

  renderViewCommentAndGetComment = (feed, id) => {
    this.setState((prev) => ({
      showViewCommentModal: !prev.showViewCommentModal,
      specialFeed: feed,
      selectedFeedId: id
    }))
    this.props.getInspirationPost(id);
    this.getCommentsForPostModal(id)
    // this.handleScrollTrigger();
  }

  getCommentsForPostModal = (id) => {
    const { fetchCommentsOnPost } = this.props;
    fetchCommentsOnPost(id);
  };

  // getGlobalAnnouncementData = async()=>{
  //   const{userCompanyId } = this.props;
  //   const res = await fetchApi(GetSocialTipsAndQuotes + "/" + userCompanyId, "GET");
  //   this.setState({defaultReactions:res.data.reaction_icons})
  // }

  getBadgeGradient = (levelName) => {
    const gradients = {
      starter:    'linear-gradient(90deg, #40A075 0%, #54BB8D 51.59%, #40A075 100%)',
      builder:    'linear-gradient(90deg, #987F01 0%, #D5B201 51.59%, #987F01 100%)',
      mover:      'linear-gradient(90deg, #006C8F 0%, #0096C7 51.59%, #006C8F 100%)',
      challenger: 'linear-gradient(90deg, #0040AD 0%, #146BFF 51.59%, #0040AD 100%)',
      elite:      'linear-gradient(90deg, #851600 0%, #D63200 51.59%, #851600 100%)',
    };
    return gradients[(levelName || '').toLowerCase()] || gradients.starter;
  };

  renderMonthlyChallengeFeed = () => {
    const { feed } = this.props;
    const challenge = feed?.post_achievement;
    const owner = feed?.post_owner;

    return (
      <MonthlyGoalChallengeCard onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} style={{ cursor: 'pointer' }}>
        <img
          className="woliba-logo"
          src={ImageUrl + '/company-logo/ToZRPeButf.png'}
          alt="Woliba"
        />

        <div className="badge-section">
          <LazyImage
            className="badge-img"
            src={`${ImageUrl}/${challenge?.badge?.badge_icon}`}
            alt="badge"
          />
        </div>

        <div className="congrats-text">Congratulations</div>

        <div className="steps-pill" style={{ background: challenge?.badge?.color }}>
          {commaSeperator(challenge?.total_activity)}{" "}
          {capitalizeFirstLetter(challenge?.activity_type) || 'Steps'}
        </div>

        <div className="achieved-text">Achieved In {challenge?.month_name}</div>

        <div className="stats-row">
          <div className="stat-item">
            <div className="stat-label">Streaks</div>
            <div className="stat-value">{challenge?.longest_streak || 0} {challenge?.longest_streak > 1 ? "Days" :"Day"}</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <div className="stat-label">Daily Avg.</div>
            <div className="stat-value">{commaSeperator(challenge?.daily_average || 0)} Steps</div>
          </div>
          <div className="stat-divider" />
          <div className="stat-item">
            <div className="stat-label">XP Earned</div>
            <div className="stat-value">{challenge?.points_earned || 0} XP</div>
          </div>
        </div>

        <div className="challenge-by">A Challenge By Woliba</div>

        <div className="bottom-gradient" style={{ background: this.getBadgeGradient(challenge?.badge?.level_name) }}>
          {owner?.profile_image && !this.containsDefaultPng(owner?.profile_image) ? (
            <div className="owner-avatar-wrapper">
              <img
                src={`${ImageUrl}/${owner?.profile_image}`}
                alt={owner?.post_owner_name}
                onError={this.fallBack}
              />
            </div>
          ) : (
            <div className="owner-initials-wrapper">
              {getInitials(owner?.post_owner_name)}
            </div>
          )}
          <div className="owner-name">{owner?.post_owner_name}</div>
        </div>
      </MonthlyGoalChallengeCard>
    );
  };

  extractUrl = (text = "") => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const match = text.match(urlRegex);
    return match ? match[0] : null;
  };


  renderTextWithLinks = (text) => {
    if (!text) return "";

    const urlRegex = /((?:https?:\/\/|www\.|(?:\b\/\/))[^\s]+)/gi;
    const parts = text.split(urlRegex);

    // const urlRegex = /(https?:\/\/[^\s]+)/g;
    // const parts = text.split(urlRegex);
  
    return parts.map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: "700", color: "#184A61", textDecoration: "none" }}
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        );
      }
      // Handle new lines for plain text parts
      return part.split('\n').map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i !== part.split('\n').length - 1 && <br />}
        </React.Fragment>
      ));
    });
  };

  MomentsRightArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          backgroundColor: "rgba(9, 47, 65, 0.2)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
      >
        <svg
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.885261 16C0.797538 16.0005 0.710579 15.9837 0.629367 15.9505C0.548156 15.9173 0.474292 15.8685 0.412009 15.8067C0.349534 15.7447 0.299946 15.671 0.266106 15.5898C0.232266 15.5086 0.214844 15.4214 0.214844 15.3334C0.214844 15.2454 0.232266 15.1583 0.266106 15.0771C0.299946 14.9959 0.349534 14.9221 0.412009 14.8602L5.85774 9.41445C6.23221 9.03951 6.44255 8.53127 6.44255 8.00136C6.44255 7.47145 6.23221 6.9632 5.85774 6.58827L0.412009 1.14253C0.286495 1.01702 0.215981 0.846784 0.215981 0.66928C0.215981 0.491776 0.286495 0.321542 0.412009 0.196028C0.537523 0.0705132 0.707757 0 0.885261 0C1.06277 0 1.233 0.0705132 1.35851 0.196028L6.80425 5.64176C7.11462 5.95135 7.36086 6.31912 7.52887 6.72402C7.69689 7.12892 7.78337 7.56298 7.78337 8.00136C7.78337 8.43973 7.69689 8.8738 7.52887 9.2787C7.36086 9.68359 7.11462 10.0514 6.80425 10.361L1.35851 15.8067C1.29623 15.8685 1.22237 15.9173 1.14115 15.9505C1.05994 15.9837 0.972984 16.0005 0.885261 16Z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    );
  };

  AdminLeftArrowIcon = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          backgroundColor: "rgba(9, 47, 65, 0.2)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          position: "absolute",
          left: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="16"
          viewBox="0 0 9 16"
          fill="none"
        >
          <path
            d="M7.615 16a.666.666 0 0 0 .473-1.14L2.642 9.414a2 2 0 0 1 0-2.826l5.446-5.445a.67.67 0 1 0-.947-.947L1.696 5.642a3.333 3.333 0 0 0 0 4.719l5.445 5.446a.67.67 0 0 0 .474.193"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    );
  };

  render() {
    const { commentText,  showAddBuddy, showRemoveBuddyPopUp, showFullText,showReportPopup, postIdValue, reactionHoverFeed, /*feedLikeStatus, likedType*/ linkMetadata } = this.state;
    const { feed, userId, /*commentCount,*/ buddyDetails, history, socialCallBack, /*description,*/ t, hideValuesInCommentsModel, privacyPopupHandle, socialFeedReactions, hideLikeCommentActivity,isFlaggedPost } = this.props; 
    const{text}=feed;


    // const metadata = this.state.linkMetaMap[feed.id];
    // let tranlsatedDescription = this.props.t(this.props.description);
    let tranlsatedDescription = this.props.t(text);
    let feedMultipleImages = {
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      draggable: true,
      adaptiveHeight: true,
      // nextArrow: <img src={ImageUrl+"/social-feed/rightArrow.svg"} style={{width:"24px", height:"24px"}}/>,
      // prevArrow: <img src={ImageUrl+"/social-feed/leftArrow.svg"} style={{width:"24px", height:"24px"}}/>,
      nextArrow: <this.MomentsRightArrow />,
      prevArrow: <this.AdminLeftArrowIcon />,
      responsive: [
        {
          breakpoint: 1252,
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: <this.MomentsRightArrow />,
            prevArrow: <this.AdminLeftArrowIcon />,
          },
        },
        {
          breakpoint: 600,
          settings: {
            dots: true,
            infinite: true,
            speed: 500,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
          },
        },
      ],
    };
    const isPostOwner = userId === feed?.post_owner?.uid;
    const shouldShow = (isPostOwner && !hideValuesInCommentsModel) || isFlaggedPost;

    // let lang = localStorage.getItem("lang");
    return (
      <div id={feed.id} key={feed.id + "key"} style={{background:"white", borderRadius: isFlaggedPost ? "12px": "4px"}}>
        <PostTopSection isFlaggedPadding={ isFlaggedPost ? "20px 20px 0px 20px" : "20px"}>
          <div className='image'>
            {!this.containsDefaultPng(feed?.post_owner?.profile_image)?
              <img src={ImageUrl + "/" +feed?.post_owner?.profile_image}/>:
              <UserInitialsMain border isWidth={"48px"} isHeight={"48px"} size={"16px"}  isBg color="#184A61">{`${getInitials(feed?.post_owner?.post_owner_name)}`}</UserInitialsMain>}
          </div>
          <div className='userDetails'>
            <div className='name'>  {(feed?.post_owner?.post_owner_name)}</div>
            <div className='city'>{feed?.post_owner?.location} {feed?.post_owner?.location ?  <span>|</span> : null}
              <span> {feed?.time_ago}</span> {feed?.type_id === 1 || feed?.type_id === 2 ? <span>| </span> : null}

              {feed?.type_id === 1 || feed?.type_id === 2 ? userId == feed?.post_owner?.uid ? <span className='icon' onClick={()=>privacyPopupHandle(feed)}>{feed?.visibility === "my-community" ? CommunityIcon():PublicIcon()} </span> :<span className='icon' style={{cursor:"default"}}>{feed?.visibility === "my-community" ? CommunityIcon("#7C7C7C"):PublicIcon("#7C7C7C")} </span> : null} 
            </div>
          </div>
          <div className='buttonWrapper'>
            {feed.friend_status === 0 && userId != feed?.post_owner?.uid && !isFlaggedPost ?
              <AddButton onClick={() => this.addBuddyApiCall(feed?.post_owner?.uid)}>
                <div className='namess'>
                  {"Connect"}
                </div>
                <div className='icons'>
                  {/* <img src={ImageUrl+"/social-feed/add-buddy.svg"}/> */}
                  <div className='icon'>{AddBuddyIconNew()}</div>
                </div>
              </AddButton>:
              feed.friend_status === 2 && userId != feed?.post_owner?.uid && !isFlaggedPost ?
                <AddButton onClick={() => this.showAddBuddyPopUp(feed?.post_owner?.uid)}>
                  <div className='name'>
                    {"Pending"}
                  </div>
                  <div className='icons'>
                    {/* <img src={ImageUrl+"/social-feed/pending.svg"}/> */}
                    <div className='icon'>{PendingIcon()}</div>
                  </div>
                </AddButton>:null
            }
            {shouldShow &&
            <DownAngleV2 feed>
              <DropdownButton id="deleteTour" title={<VerticalDotsIcon/>}>
                
                <Dropdown.Item onClick={() => this.props.changeEditDeletePopup('delete', feed, isFlaggedPost)}>
                  {t("Delete Post")}
                </Dropdown.Item>
                <Dropdown.Item onClick={this.toggleEditPopup}>
                  {t("Edit Post")}
                </Dropdown.Item>
              </DropdownButton>
            </DownAngleV2>}


            {
              (userId !== feed?.post_owner?.uid)  && feed.core_value_id === null  && !isFlaggedPost && (feed.type_id === 1 || feed.type_id === 2) &&
            <DownAngleV2  feed>
              <div id="repostTour">
                <DropdownButton id="editDelete" title={<VerticalDotsIcon/>}>
                  <Dropdown.Item onClick={this.showReportPostPopup}>
                    {t("Report Post")}
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </DownAngleV2>}

          </div>
         
        </PostTopSection>
        { isFlaggedPost ? <Divider isMargin={"8px 0px 8px 20px"} isWidth={"94%"}/> :null}
        <FeedInformation background="white" style={{borderRadius: isFlaggedPost ? "12px": ""}}>
          {/* {text != null && text !== '' && <Description text={showFullText && (postIdValue==feed.id) ?"":feed.mentioned_post.length==0? "100px":"40px"} padding={(text?.length>137|| tranlsatedDescription?.length>137)?"20px":"0px"} style={{marginBottom:feed?.post_images?.length>0?"20px":"0px"}} width="true" contents> <div className='truncate'>{createSafeHTML(text ? convertUnicode(tranlsatedDescription).split('\\n').join('<br />') : '')}</div>
            {((feed.mentioned_post.length>0 && text?.length>130|| feed.mentioned_post.length>0 && tranlsatedDescription?.length>130) && !showFullText) ?<div  onClick={() => this.showFullText(feed.id)} className='more-text'>... more</div>:
              postIdValue==feed.id&&showFullText?null:  feed.mentioned_post.length==0&&text?.length>324?<div onClick={() => this.showFullText(feed.id)} className='more-text'>... more</div>:null  
            }
          </Description>} */}
          {text && (
            <Description 
              text={showFullText && (postIdValue==feed.id) ? "auto" :"40px"} 
              padding={(text?.length > 154 || tranlsatedDescription?.length > 154) ? "20px" : "0px"} 
              style={{ marginBottom: feed?.post_images?.length > 0 ? "20px" : "0px" }} 
              width="true" 
              contents
            >
              {/* <div className='truncate'>
                {createSafeHTML(text  ? convertUnicode(tranlsatedDescription).split('\\n').join('<br />') : '')}
              </div> */}

              <div className='truncate'>
                {(() => {
                  const rawText = convertUnicode(tranlsatedDescription || "");
                  const urlRegex = /((?:https?:\/\/|www\.|(?:\b\/\/))[^\s]+)/gi;
            
                  // IF URL EXISTS: Use the React Helper (Safe, Bold, Clickable)
                  if (urlRegex.test(rawText)) {
                    return this.renderTextWithLinks(rawText);
                  } 
                  
                  // IF NO URL: Use your original createSafeHTML
                  return createSafeHTML(text ? rawText.split('\\n').join('<br />') : '');
                })()}
              </div>
              {!showFullText && (
                (text?.length > 154 || tranlsatedDescription?.length > 154) ||
                ( text?.length > 324)
              ) && (
                <div onClick={() => this.showFullText(feed.id)} className='more-text'>... more</div>
              )}
            </Description>
          )}


          {linkMetadata &&(
            <LinkPreviewCard style={{margin:"16px", width:"536px", cursor:"pointer"}} onClick={() => window.open(this.state.linkMetadata.url, "_blank")}>
              <div className="previewContainer">
                {linkMetadata.image && (
                  <img
                    src={linkMetadata.image}
                    className="previewImage"
                    alt="preview"
                  />
                )}
          
                <div className="previewContent">
                  <div className="previewTitle">
                    {linkMetadata.title}
                  </div>
          
                  <div className="previewUrl">
                    {linkMetadata.url}
                  </div>
                </div>
              </div>
            </LinkPreviewCard>
          )}

          {feed.type_id === 9 ? this.renderMonthlyChallengeFeed() :feed.type_id === 7 ?<ShareWorkoutCard workoutData={feed?.post_log_workout}/>  : (feed?.post_images?.length>1 || feed?.moment_images?.length>1)&& this.state.hideCommentText && !feed.core_value && feed.type_id != 1 ?
            (feed?.post_images?.length==2 || feed?.moment_images?.length==2) ?
              <MultiphotoWrapper onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)}>
                <Multiphoto width="100%" height="283px" isPhotoShrink="true">
                  <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[0]?.image_url : feed?.post_images?.[0]?.image_url}`}/>
                </Multiphoto>
                <Multiphoto width="100%" height="283px" isPhotoShrink="true">
                  <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[1]?.image_url : feed?.post_images?.[1]?.image_url}`}/>
                </Multiphoto>
              </MultiphotoWrapper>:
              (feed?.post_images?.length==3 || feed?.moment_images?.length==3) ?
                <MultiphotoWrapper onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)}>
                  <Multiphoto width="100%" height="283px">
                    <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[0]?.image_url : feed?.post_images?.[0]?.image_url}`}/>
                  </Multiphoto>
                  <div className='image-wrap'>
                    <Multiphoto width="50%" height="283px">
                      <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[1]?.image_url : feed?.post_images?.[1]?.image_url}`}/>
                    </Multiphoto>
                    <Multiphoto width="50%" height="283px">
                      <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[2]?.image_url : feed?.post_images?.[2]?.image_url}`}/>
                    </Multiphoto>
                  </div>
                </MultiphotoWrapper>:
                feed?.post_images?.length==4 || feed?.moment_images?.length==4?
                  <MultiphotoWrapper onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)}>
                    <Multiphoto width="100%" height="283px">
                      <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[0]?.image_url : feed?.post_images?.[0]?.image_url}`}/>
                    </Multiphoto>
                    <div className='image-wrap'>
                      <Multiphoto width="188px" height="188px">
                        <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[1]?.image_url : feed?.post_images?.[1]?.image_url}`}/>
                      </Multiphoto>
                      <Multiphoto width="188px" height="188px">
                        <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[2]?.image_url : feed?.post_images?.[2]?.image_url}`}/>
                      </Multiphoto>
                      <Multiphoto width="188px" height="188px">
                        <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[3]?.image_url : feed?.post_images?.[3]?.image_url}`}/>
                      </Multiphoto>
                    </div>
                  </MultiphotoWrapper>:
                  (feed?.post_images?.length>4 || feed?.moment_images?.length > 4) &&
                   <MultiphotoWrapper onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)}>
                     <Multiphoto width="100%" height="378px">
                       <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[0]?.image_url : feed?.post_images?.[0]?.image_url}`}/>
                     </Multiphoto>
                     <div className='image-wrap'>
                       <Multiphoto width={isFlaggedPost ? "200px" : "188px"} height="188px">
                         <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[1]?.image_url : feed?.post_images?.[1]?.image_url}`}/>
                       </Multiphoto>
                       <Multiphoto  width={isFlaggedPost ? "201px" : "188px"} height="188px">
                         <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[2]?.image_url : feed?.post_images?.[2]?.image_url}`}/>
                       </Multiphoto>
                       <Multiphoto  width={isFlaggedPost ? "200px" : "188px"} isFlaggedTrue={ isFlaggedPost ? "200px" : "188px"}  height="188px" background="1">
                         <img onError={this.fallBack} src={`${ImageUrl}/${feed?.moment_images?.length ? feed?.moment_images?.[3]?.image_url : feed?.post_images?.[3]?.image_url}`}/>
                         <div className='backdrop'>+{(feed?.moment_images?.length ? feed?.moment_images?.length : feed?.post_images.length)-4}</div>
                       </Multiphoto>
                     </div>
                   </MultiphotoWrapper>:
            feed?.recognition_recipients?.length>1 && feed.type_id !=1 && this.state.hideCommentText && feed.type_id !=4 &&  feed.type_id !=5?
              <SliderContainer
                display="flex"
                content="center"
                shadow="0px 8px 25px 0px #0D427040"
              >
                <Slider {...feedMultipleImages} style={{width:"568px"}}>
                  {feed && feed.post_images && feed?.recognition_recipients.map((data,index)=>(
  
                    data.recognized_user_name?(feed.type_id==4||feed.type_id===5)?
                      <RecognitionBirthdayAnniversary margin image={data?.post_template?.bg_image} onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} height="568px">
                        <div className='mainContainer'>
                          <div className='wish'>{feed.type_id===5?"Happy Work Anniversary!":"Happy Birthday!"}</div>
                          <div className='wish-name'>{data.recognized_user_name}</div>
                          <div className='image'>
                            <div className='imageWidth'>
                              {data?.profile_image && !this.containsDefaultPng(data?.profile_image)?
                                <img onError={this.fallBack} src={`${ImageUrl}/${data?.profile_image}`}/>:
                                <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(data?.recognized_user_name)}</UserInitials>}
                            </div>
                          </div>
                          {feed.type_id===5?
                            <div className='message'>Your dedication and hard work have been an inspiration to us <br/> all. Here’s to many more years of success together!</div>:
                            <div className='message'>May this year bring you continued success and fulfillment in <br/>both your personal and professional life.</div>}
                        </div>
                      </RecognitionBirthdayAnniversary>:
                      <RecognitionImage margin image={feed?.post_recognitions?.bg_image} key={index} onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} height="380px">
                        <div className='mainContainer'>
                          <div className='image'>
                            <div className='imageWidth'>
                              {data?.profile_image && !this.containsDefaultPng(data?.profile_image)?
                                <img src={`${ImageUrl}/${data?.profile_image}`}/>:
                                <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(data?.recognized_user_name)}</UserInitials>}
                            </div>
                            <RecogntionContainer border={feed?.post_recognitions?.recognition_color_value}>
                              <div className='recogntionvalue'>
                                <div className='image'>
                                  <img src={`${ImageUrl}/${feed?.post_recognitions?.image}`}/>
                                </div>
                                <div className='name'>
                                  {feed?.post_recognitions?.core_value}
                                </div>
                              </div>
                            </RecogntionContainer>
                            <div className='recognition'>
                              <span className='textRecognition'>{"Congratulations to"}</span>
                              <span className='boldRecognition'>{data?.recognized_user_name}</span>
                              {CongratulationsEmojiIcon()}
                            </div>
                          </div>
                        </div>
                      </RecognitionImage>:
                      <WrapImage noMargin onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} key={index}>
                        <img src={`${ImageUrl}/${data.profile_image}`} alt={data.body || 'placeholder'} />
                      </WrapImage>))}
                </Slider>
              </SliderContainer> :
              feed?.post_user_wishes?.length>=1 && (feed?.type_id ===4 ||  feed?.type_id ===5) && this.state.hideCommentText?
                <SliderContainer
                  display="flex"
                  content="center"
                  shadow="0px 8px 25px 0px #0D427040"
                >
                  <Slider {...feedMultipleImages} style={{width:"568px"}}>
                    {feed && feed.post_images && feed?.post_user_wishes.map((data,index)=>(
     
                      data.user_name?(feed.type_id===4||feed.type_id===5)?
                        <RecognitionBirthdayAnniversary isImageMargin={"141px auto 4px auto"} margin image={feed?.post_template?.bg_image} onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} height="568px">
                          <div className='mainContainer'>
                            {/* <div className='wish'>{feed.type_id===5?"Happy Work Anniversary!":"Happy Birthday!"}</div> */}
                            <div className='image'>
                              <div className='imageWidth'>
                                {data?.profile_image && !this.containsDefaultPng(data?.profile_image)?
                                  <img onError={this.fallBack} src={`${ImageUrl}/${data?.profile_image}`}/>:
                                  <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(data?.user_name)}</UserInitials>}
                              </div>
                            </div>
                            <div   style={{color: getReceiverNameColor(feed?.type_id, feed?.post_template_id)}} className='wish-name'>{data.user_name}</div>
                            {/* {feed.type_id===5?
                              <div className='message'>Your dedication and hard work have been an inspiration to us <br/> all. Here’s to many more years of success together!</div>:
                              <div className='message'>May this  year bring you continued success and fulfillment in <br/>both your personal and professional life.</div>} */}
                          </div>
                        </RecognitionBirthdayAnniversary>:
                        <RecognitionImage margin image={feed?.post_recognitions?.bg_image} key={index} onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} height="380px">
                          <div className='mainContainer'>
                            <div className='image'>
                              <div className='imageWidth'>
                                {data?.profile_image && !this.containsDefaultPng(data?.profile_image)?
                                  <img src={`${ImageUrl}/${data?.profile_image}`}/>:
                                  <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(data?.user_name)}</UserInitials>}
                              </div>
                              <RecogntionContainer border={feed?.post_recognitions?.recognition_color_value}>
                                <div className='recogntionvalue'>
                                  <div className='image'>
                                    <img src={`${ImageUrl}/${feed?.post_recognitions?.image}`}/>
                                  </div>
                                  <div className='name'>
                                    {feed?.post_recognitions?.core_value}
                                  </div>
                                </div>
                              </RecogntionContainer>
                              <div className='recognition'>
                                <span className='textRecognition'>{"Congratulations to"}</span>
                                <span className='boldRecognition'>{data?.user_name}</span>
                                {CongratulationsEmojiIcon()}
                              </div>
                            </div>
                          </div>
                        </RecognitionImage>:
                        <WrapImage noMargin onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} key={index}>
                          <img src={`${ImageUrl}/${data.profile_image}`} alt={data.body || 'placeholder'} />
                        </WrapImage>))}
                  </Slider>
                </SliderContainer>
                :(feed?.post_images?.length === 1 || feed?.moment_images?.length === 1)  && this.state.hideCommentText  ? 
                  <WrapImage noMargin onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)}   style={{  padding: isFlaggedPost ? "0px 0px 0px 16px" : ""}}>
                    <LazyImage src={`${ImageUrl}/${feed?.moment_images?.length === 1 ? feed?.moment_images?.[0]?.image_url : feed?.post_images[0]?.image_url}`} alt={feed.body || 'placeholder'} />
                  </WrapImage>: 
                  feed.type_id?
                    (feed.type_id===4||feed.type_id===5)?
                      <RecognitionBirthdayAnniversary margin image={feed?.post_template?.bg_image} onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} height="568px">
                        <div className='mainContainer'>
                          <div className='wish'>{ feed?.post_template?.title}</div>
                          <div className='wish-name'>{feed?.recognition_recipients[0]?.recognized_user_name}</div>
                          <div className='image'>
                            <div className='imageWidth'>
                              {feed?.recognition_recipients[0]?.profile_image && !this.containsDefaultPng(feed?.recognition_recipients[0]?.profile_image)?<img src={`${ImageUrl}/${feed?.recognition_recipients[0]?.profile_image}`}/>:
                                <UserInitials color={feed?.post_recognitions?.recognition_color_value}>{getInitials(feed?.recognition_recipients[0]?.recognized_user_name)}</UserInitials>}
                            </div>
                          </div>
                          {feed.type_id===5?
                            <div className='message'>Your dedication and hard work have been an inspiration to us <br/> all. Here’s to many more years of success together!</div>:
                            <div className='message'>May this year bring you continued success and fulfillment in<br/>both your personal and professional life.</div>}
                        </div>
                      </RecognitionBirthdayAnniversary>
                      :feed.type_id !=1 && <RecognitionImage margin image={feed?.post_recognitions?.bg_image} onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} height="380px">
                        <div className='mainContainer'>
                          <div className='image'>
                            <div className='imageWidth'>
                              {feed?.recognition_recipients[0]?.profile_image && !this.containsDefaultPng(feed?.recognition_recipients[0]?.profile_image)?<img src={`${ImageUrl}/${feed?.recognition_recipients[0]?.profile_image}`}/>:
                                <UserInitials isFont={"64px"} color={"#092F41"}>{getInitials(feed?.recognition_recipients[0]?.recognized_user_name)}</UserInitials>}
                            </div>
                            <RecogntionContainer border={feed?.post_recognitions?.recognition_color_value}>
                              <div className='recogntionvalue'>
                                <div className='image'>
                                  <img src={`${ImageUrl}/${feed?.post_recognitions?.image}`}/>
                                </div>
                                <div className='name'>
                                  {feed?.post_recognitions?.core_value}
                                </div>
                              </div>
                            </RecogntionContainer>
                            <div className='recognition'>
                              <span className='textRecognition'>{"Congratulations to"}</span>
                              <span className='boldRecognition'>{feed?.recognition_recipients[0]?.recognized_user_name}</span>
                              {CongratulationsEmojiIcon()}
                            </div>
                          </div>
                        </div>
                      </RecognitionImage>:null}
          {/* {(feed?.post_like_users?.length>0||commentCount>0)&&<div style={{background:"rgba(0, 92, 135, 0.10)", borderTop:"12px", height:"1px"}}></div>}
          {(feed?.post_like_users?.length>0||commentCount>0)?<LikeCommentCount>
            <div>
              {
                feed && feed.post_like_users && feed.post_like_users.length > 0 ?
                  feed.post_like_users && feed.post_like_users.length === 1 ? (
                    <span id={`like-${feed.id}-text`} className='simpletext'>{"Liked by"}&nbsp;{feed.post_like_users[0].fullname}</span>
                  ) : (
                    feed.post_like_users && feed.post_like_users.length > 1 ? (
                      <>
                        <span className='simpletext'>{"Liked by"}&nbsp;{`${feed.post_like_users[0].fullname}`} &nbsp;{this.props.t("and")}&nbsp;</span> <span className='boldText' onClick={this.handleLikePopUp}>{`${feed.post_like_users.length - 1} `+this.props.t(" others")}</span>
                      </>
                    ) : (
                      <div />
                    )) : null
              }
            </div> */}



          {(feed?.post_likes?.length>0||feed?.post_comments_count>0) && !isFlaggedPost &&<div style={{background:"rgba(0, 92, 135, 0.10)", borderTop:"12px", height:"1px"}}></div>}
          {}
          {(feed?.post_likes?.length>0||feed?.post_comments_count>0)?<LikeCommentCount>
            <div onClick={this.handleLikePopUp}>
              {feed?.reactions?.length ?               <PostReactionsContainer>
                {feed?.reactions.map((reaction, index) => (
                  <div key={reaction} className='icon-container' 
                    // style={{    position: "relative",right: index > 0 && "8px"}}
                    style={{
                      marginLeft: index === 0 ? "0px" : "-8px" // Overlap effect
                    }}
                  >
                    <LazyImage
                      src={ImageUrl+`/social-feed-reactions/${reaction}.png`}
                      alt={reaction}
                      // className={`reaction-icon ${selectedReaction === reaction ? 'selected' : ''}`}
                      // onClick={() => this.handleReactionClick(reaction)}
                      className={"icon"}
   
                    />
                  </div>
                ))}
              </PostReactionsContainer> :null}
              &nbsp;
              {
                feed?.post_likes_count > 0 ?
                  feed?.post_likes_count === 1 ? (
                    <span id={`like-${feed.id}-text`} className='simpletext'>&nbsp;{feed?.post_likes?.[0]?.liked_by}</span>
                  ) : (
                    feed?.post_likes_count > 1 ? (
                      <>
                        <span className='simpletext'>&nbsp;{`${feed?.post_likes?.[0]?.liked_by}`} &nbsp;{this.props.t("and")}&nbsp;</span> <span className='boldText'>{`${feed.post_likes_count - 1} `+this.props.t(" others")}</span>
                      </>
                    ) : (
                      <div />
                    )) : null
              }
            </div>
            {feed?.post_comments_count>0?<div>
              <span className='commentText' onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)}> <div className='commentCount'>{feed?.post_comments_count}</div> &nbsp;{feed?.post_comments_count>1?t("Comments"): t("Comment")}</span>
            </div>:null} 
          </LikeCommentCount>:null}
          {hideLikeCommentActivity ? null : <LikeCommentButtonSection >
            <div className='likeSection' id='tourLike' style={{marginRight:"80px"}} onMouseEnter={() => this.onReactionEnterMouse(feed.id)}
              onMouseLeave={() => this.onReactionLeaveMouse()}>
              {/* <LikeCommentButton onClick={this.likeUnlikePost} style={{alignItems:"center"}}> 
                <div className='icon' style={{width:feedLikeStatus ? "40px" : "24px",height:feedLikeStatus ? "40px" : "24px",display:"flex",alignItems:"center"}}>
                  {feedLikeStatus ?<img src={ImageUrl+`/social-feed-reactions/${likedType}.png`} />:<img src={ImageUrl+`/social-feed/like.png`} />}
                </div>
                <div className='text'>{likedType ? likedType  : "Like"}</div>
              </LikeCommentButton> */}
              <LikeCommentButton onClick={this.likeUnlikePost} style={{alignItems:"center"}}>
                <div className='icon' style={{width:feed?.liked_status ? "40px" : "24px",height:feed?.liked_status ? "40px" : "24px",display:"flex",alignItems:"center"}}>
                  {feed?.liked_status ?<img src={ImageUrl+`/social-feed-reactions/${feed?.liked_type}.png`} />:<img src={ImageUrl+`/social-feed/like.png`} />}
                </div>
                <div className='text'>{feed?.liked_type ? feed?.liked_type  : "Like"}</div>
              </LikeCommentButton>
              {reactionHoverFeed === feed.id ?               <ReactionsContainer>
                <div className='rounded-container'>
                  {socialFeedReactions && Object?.entries(socialFeedReactions)?.map(([reaction, imagePath]) => (
                    <div key={reaction} className='icon-container'>
                      <LazyImage
                        src={ImageUrl + "/" + imagePath}
                        alt={reaction}
                        // className={`reaction-icon ${selectedReaction === reaction ? 'selected' : ''}`}
                        onClick={() => this.handleReactionClick(reaction)}
                        className={"icon"}
                      />
                    </div>
                  ))}
                </div>
              </ReactionsContainer> :null}

              {/* <ReactionsContainer>
                <div className='rounded-container'>
                  {Object.entries(defaultReactions).map(([reaction, imagePath]) => (
                    <div key={reaction} className='icon-container'>
                      <LazyImage
                        src={ImageUrl + "/" + imagePath}
                        alt={reaction}
                        // className={`reaction-icon ${selectedReaction === reaction ? 'selected' : ''}`}
                        onClick={() => this.handleReactionClick(reaction)}
                        className={"icon"}

                      />
                    </div>
                  ))}
                </div>
              </ReactionsContainer> */}
            </div>
            <div id="commentTour" className='commentSection'>
              <LikeCommentButton onClick={() => this.renderViewCommentAndGetComment(feed, feed.id)} style={{alignItems:"center"}}>
                <div className='icon'>
                  {/* <img src={ImageUrl+"/social-feed/comment.png"} /> */}
                  {SocialFeedCommentIcon()}
                </div>
                <div className='text'>Comment</div>
              </LikeCommentButton>
            </div>
          </LikeCommentButtonSection> }     
        </FeedInformation>

        
        {this.state.showTextArea && this.renderTextArea(commentText)}
        {this.state.showRecognitionModal && this.renderRecognitionModal()}
        {showRemoveBuddyPopUp&&<RemoveFriendPopup
          showModal={showRemoveBuddyPopUp}
          onClose={this.displayRemovePopUp}
          buddyDetails={feed}
          history={history}
          showRemoveBuddyPopUp={showRemoveBuddyPopUp}
          hideCancel={1}
          socialCallBack={socialCallBack}
        />}
        {showAddBuddy&&<DeletePostPopUp
          showModal={showAddBuddy}
          onClose={this.showAddBuddyPopUp2}
          buddyDetails={buddyDetails}
          showRemoveBuddyPopUp={showRemoveBuddyPopUp}
          hideCancel={0}
          socialCallBack={socialCallBack}
          pendingStatus={feed.friend_status === 2}
          showpending= {feed.friend_status === 2}
          showAddBuddy={feed.friend_status===0}
          showConfirm={feed.friend_status===5}
          requestId={feed.request_id}
        />}
        { showReportPopup &&
          <ReportPostPopup
            show={showReportPopup}
            onClose={this.closeReportPostPopup}
            postId={feed?.id}
            getFeedHighlights={this.props.getFeedHighlights}
          />
        }

        {this.state.showViewCommentModal ?  
          <ViewCommentModal onClose={()=>this.setState({showViewCommentModal:false})} showModal={this.state.showViewCommentModal} feed={feed}
            description={feed?.description}
            taggedUsers={feed?.shoutout_user_name}
            getCommentsForPost={this.props.getCommentsForPost}
            changeEditDeletePopup={this.props.changeEditDeletePopup}
            editAndDelete={this.props.editAndDelete}
            openEditAndDelete={this.props.openEditAndDelete}
            profileImage={this.props.profileImage}
            updationList="response"
            commentCount={feed?.comment_count}
            history={this.props.history}
            enableTrigger={this.props.enableTrigger}
            key={`feed-${feed?.id}`}
            onChange={this.props.onChange}
            // handleFeed={this.props.handleFeed}
            // handleModal={this.props.handleModal}
            feedNumber={this.props.feedNumber}
            data={this.props.postLikeDetails}
            exemplifiesValues={this.props.exemplifiesValues}
            showRecognition={this.props.showRecognition}
            value={this.props.value}
            id={this.props.id}
            image={this.props.image}
            feedNo={this.props.feedNo}
            updateFeedsLike={this.props.updateFeedsLike}
            storedFeeds={this.props.feeds}
            editPost={this.props.editPostModel}
            socialCallBack={this.props.socialCallBack}
            handlePhotoPostModal={this.props.handlePhotoPostModal}
            comments={this.props.comments}
            postReply={this.props.postReplyOnComment}
            replySuccess={this.props.replySuccess}
            user={this.props.user}
            defaultReactions={socialFeedReactions}
            privacyPopupHandle={this.props.privacyPopupHandle}
            isFromSingleFeed={true}
            likeUnlikeSingleFeedPost={this.likeUnlikePost}
            handleReactionSingleFeedPost={this.handleReactionClick}
            isFlaggedPost={this.props.isFlaggedPost}
            // feedLikeStatus={feedLikeStatus}
            // likedType={likedType}
          /> : null}
        {this.state.showEditPopup && (
          <EditPostPopup
            showModal={this.state.showEditPopup}
            onClose={this.toggleEditPopup}
            feed={feed}
            updationList={this.props.updationList || 'response'}
          />
        )}


      </div>
    )
  }
}

SingleFeed.propTypes = {
  feed: PropTypes.object.isRequired,
  disableLikeButton: PropTypes.func.isRequired,
  disableButton: PropTypes.bool,
  postComment: PropTypes.func.isRequired,
  likeOrUnlikePost: PropTypes.func.isRequired,
  successLikeOrUnlike: PropTypes.string,
  getCommentsForPost: PropTypes.func.isRequired,
  getCommentsForPostModal: PropTypes.func.isRequired,
  profileImage: PropTypes.string,
  fetchUserName: PropTypes.func.isRequired,
  userName: PropTypes.string,
  updationList: PropTypes.string,
  changeEditDeletePopup: PropTypes.func.isRequired,
  openEditAndDelete: PropTypes.func.isRequired,
  editAndDelete: PropTypes.bool.isRequired,
  userId: PropTypes.number,
  fetchUserId: PropTypes.func,
  history: PropTypes.object,
  description: PropTypes.string,
  commentCount: PropTypes.number,
  fetchUserPosts: PropTypes.func.isRequired,
  taggedUsers: PropTypes.string,
  userCompany: PropTypes.object.isRequired,
  enableTrigger: PropTypes.bool,
  buddyDetails: PropTypes.array,
  sendFriendRequest: PropTypes.func,
  onChange: PropTypes.func,
  handleModal: PropTypes.func.isRequired,
  handleFeed: PropTypes.func,
  unFriendUser: PropTypes.func,
  getPostLikeDetails: PropTypes.func,
  feedNumber: PropTypes.number,
  postLikeDetails: PropTypes.array,
  data: PropTypes.array.isRequired,
  addBuddy: PropTypes.func,
  exemplifiesValues: PropTypes.array,
  showRecognition: PropTypes.func,
  feedNo: PropTypes.number,
  value: PropTypes.string,
  id: PropTypes.number,
  image: PropTypes.string,
  updateFeedsLike: PropTypes.func,
  editPost: PropTypes.func,
  storedFeeds: PropTypes.array,
  socialCallBack: PropTypes.func,
  handlePhotoPostModal: PropTypes.func,
  comments: PropTypes.array,
  postReply: PropTypes.func,
  replySuccess: PropTypes.string,
  hideCommentText: PropTypes.bool,
  showViewCommentModal: PropTypes.bool,
  renderViewCommentModal: PropTypes.func,
  specialFeed: PropTypes.object,
  renderViewCommentAndGetComment: PropTypes.func,
  handleScrollTrigger: PropTypes.func,
  t: PropTypes.func,
  hideValuesInCommentsModel: PropTypes.bool,
  selectedFeedId: PropTypes.bool,
  getSuggestionsList: PropTypes.func,
  privacyPopupHandle: PropTypes.func,
  defaultReactions:PropTypes.object,
  hideLikeCommentActivity:PropTypes.bool,
  isFlaggedPost:PropTypes.bool,
  getFeedHighlights:PropTypes.func,
  feeds:PropTypes.array,
  editPostModel:PropTypes.bool,
  postReplyOnComment:PropTypes.bool,
  getInspirationPost:PropTypes.func,
  user:PropTypes.string,
  updateSocialFeedPost:PropTypes.func,
  updateDetailPost:PropTypes.func,
  fetchCommentsOnPost:PropTypes.func,
  userCompanyId:PropTypes.number,
  socialFeedReactions:PropTypes.object
};

const mapStateToProps = (state) => ({
  success: state.social.success,
  userId: state.profileData.userId,
  userCompany: state.profileData.userCompany,
  postLikeDetails: state.social.postLikeDetails,
  buddyDetails: state.social.buddyDetails,
  userPosts: state.social.userPosts,
  user: state.profileData.user,
  userCompanyId: state.profileData.companyDetails.id,
  socialFeedReactions:state.social.socialFeedReactions
});

const mapDispatchToProps = (dispatch) => ({
  postComment: (commentData, updationList) => dispatch(addCommentOnPost(commentData, updationList)),
  disableLikeButton: () => dispatch(disableButton()),
  likeOrUnlikePost: (data, updationList) => dispatch(likeUnlikePost(data, updationList)),
  fetchUserName: () => dispatch(getUserName()),
  fetchUserId: () => dispatch(getUserId()),
  fetchUserPosts: (id, history) => dispatch(getUserPosts(id, history)),
  sendFriendRequest: (buddyId, bool) => dispatch(sendFriendRequest(buddyId, bool)),
  unFriendUser: (data, bool) => dispatch(unFriendUser(data, bool)),
  getPostLikeDetails: (data) => dispatch(getPostLikeDetails(data)),
  addBuddy: (data) => dispatch(addBuddy(data)),
  getSuggestionsList: () => dispatch(getSuggestionsList()),
  getFeedHighlights: (id) => dispatch(getFeedHighlights(id)),
  updateSocialFeedPost: (payload) => dispatch(updateSocialFeedPost(payload)),
  updateDetailPost: (data) => dispatch(updateDetailPost(data)),
  getInspirationPost: (id) => dispatch(getInspirationPost(id)),
  fetchCommentsOnPost: (id) => dispatch(getCommentsOnPost(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation())(SingleFeed));